import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const date_format = 'D MMM YYYY';

const formatDate = (date) => {
	const m = moment(date);
	return m.isValid() ? m.format(date_format) : '';
};

const SettlePaymentReservationsListItem = ({ booking }) => {
	const { t } = useTranslation();
	const hotel = _.get(booking, 'hotel');
	const checkIn = formatDate(_.get(booking, 'deal.details.check_in'));
	const checkOut = formatDate(_.get(booking, 'deal.details.check_out'));

	return (
		<div className="settle-payment-reservations-list__item">
			<div className="settle-payment-reservations-list__item-hotel">{hotel?.name}</div>
			<div className="settle-payment-reservations-list__item-row">
				<div className="settle-payment-reservations-list__item-field">
					<div className="settle-payment-reservations-list__item-field-title">{t('ReservationID')}</div>
					<div className="settle-payment-reservations-list__item-field-content">
						{booking.short_id || booking._id}
					</div>
				</div>
				<div className="settle-payment-reservations-list__item-field">
					<div className="settle-payment-reservations-list__item-field-title">{t('CheckIn')}</div>
					<div className="settle-payment-reservations-list__item-field-content">{checkIn}</div>
				</div>
				<div className="settle-payment-reservations-list__item-field">
					<div className="settle-payment-reservations-list__item-field-title">{t('CheckOut')}</div>
					<div className="settle-payment-reservations-list__item-field-content">{checkOut}</div>
				</div>
			</div>
		</div>
	);
};

const SettlePaymentReservationsList = ({ bookings }) => {
	const { t } = useTranslation();
	const reservations = bookings || [];

	return (
		<div className="settle-payment-reservations-list">
			<div className="settle-payment-reservations-list__header">
				{t('Bookings.SelectToPay.ReservationsSelected', { count: reservations.length })}
			</div>
			<div className="settle-payment-reservations-list__items">
				{reservations.map((booking) => (
					<SettlePaymentReservationsListItem key={booking.id} booking={booking} />
				))}
			</div>
		</div>
	);
};

export default SettlePaymentReservationsList;
